export default "__VITE_ASSET__5qZBWKff__"